module.exports = __webpack_public_path__ + "img/ico-11.34896750.svg";